<template>
  <div class="card">
    <div class="card__image-wrap">
      <img
          :class="['card__image', { loaded: isImageLoaded }]"
          :src="card.images[0].thumbnail"
          loading="lazy"
          width="620"
          height="400"
          :alt="card.title"
          ref="img"
      />

      <CardGallery :images="card.images"/>
    </div>

    <div class="card__info-wrap">
      <p class="card__title">
        <a
            class="card__title-link"
            :href="card.url"
            target="_blank"
            @click.prevent="$emit('cardPick', card.id)"
        >{{ card.title }}</a
        >
      </p>

      <p class="card__price">
        {{ priceToString(card.price) }}
      </p>

      <div v-if="card.badges.length" class="card__badge-wrap">
        <span
            v-for="(badge, index) of card.badges"
            :key="index"
            :class="'badge ' + badge.class"
        >{{ badge.text }}</span
        >

        <!-- <span class="badge badge--gold badge--gloss">Скидка от 30%</span> -->
        <!-- <span class="badge badge--green">Новинка</span> -->
        <!-- <span class="badge badge--red">Акция</span> -->
      </div>

      <Rating
          :value="(card.rating && card.rating.value) || null"
          link-url="#"
          :link-text="card.rating.text">
      </Rating>

      <div class="card__button-wrap">
        <button
            @click="$emit('cardPick', card.id)"
            class="button button--big button--primary"
        >Забронировать
        </button>

        <button class="button button--big button--i-gift">Подарить</button>
      </div>
    </div>
  </div>
</template>

<script>
import CardGallery from "./CardGallery.vue";
import Rating from "./Rating"
import priceToString from '@/mixins/price-to-string'

export default {
  components: {Rating, CardGallery},
  mixins: [priceToString],
  props: ["card"],
  data() {
    return {
      isImageLoaded: false,
    };
  },
  mounted() {
    const classesMap = {
      discount: "badge--gold badge--gloss",
      promo: "badge--red",
      new: "badge--green",
    };
    this.card.badges.forEach((badge) => (badge.class = classesMap[badge.type]));

    const loaded = () => (this.isImageLoaded = true);
    if (this.$refs.img.complete) {
      loaded();
    } else {
      this.$refs.img.addEventListener("load", loaded);
      this.$refs.img.addEventListener("error", () => {
        console.log("Card image loading error");
      });
    }
  },
};
</script>
